import { Typography } from '@mui/material'
import { Box } from '@mui/system'

const IconWithName = ({ icon, name, onClick }) => (
  <Box sx={styles.root} onClick={onClick}>
    <Box sx={styles.icon}>
      {icon}
    </Box>
    <Typography sx={styles.name}>{name}</Typography>
  </Box>
)

const styles = {
  root: {
    display: 'flex',
    alignItems: { xs: 'center', sm: 'flex-start' },
    gap: { xs: '0px', sm: '10px' },
  },
  icon: {
    '& svg': {
      color: '#ccc',
    },
    maxWidth: '20px',
    marginInlineEnd: '15px',
  },
  name: {
    fontSize: '17px !important',
  },
}

export default IconWithName
